app.config(function ($translateProvider) {
    $translateProvider.translations('zh-hk', {
        REQUEST_ERROR: '請求發生錯誤，請稍後再試',
        THIS_ENTITY_HAS_DEPENDENCIES: '記錄正在使用中,無法刪除'
    });
});
